import React, { useState } from 'react';
import { Link, Paper, Typography } from '@mui/material';
import { Navigate, Link as RouterLink } from 'react-router-dom';
import { SIGN_IN_URL } from 'common/constants/login';
import { SignUpConfirmation, SignUpForm } from './components';
import { signUpClasses, SignUpRoot } from './SignUp.styles';

const SignUp = () => {
  const [isAccountCreated, setIsAccountCreated] = useState<boolean>(false);

  if (localStorage.getItem('access')) {
    return <Navigate to="/" />;
  }

  return (
    <SignUpRoot className={signUpClasses.root}>
      <div className={signUpClasses.top}>
        {isAccountCreated ? (
          <SignUpConfirmation />
        ) : (
          <Paper className={signUpClasses.paper}>
            <SignUpForm setIsAccountCreated={setIsAccountCreated} />
          </Paper>
        )}
      </div>
      <div className={signUpClasses.bottom}>
        <Typography color="textSecondary" variant="body1">
          Have an account?{' '}
          <Link className={signUpClasses.signInLink} component={RouterLink} to={SIGN_IN_URL} variant="body1">
            Sign In!
          </Link>
        </Typography>
      </div>
    </SignUpRoot>
  );
};

export default SignUp;
